import config_prod from './ConfigProd';
import config_dev from './ConfigDev';

const ConfigResolver = {
    config: () => {
      let stageName = '';
      return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev' || stageName === 'development' ? config_dev : config_prod
    }
};

export default ConfigResolver;



// WEBPACK FOOTER //
// ./src/config/ConfigResolver.jsx